import { useContext, useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import TabelFinance from "../../../../components/tabel/tabelFinance/TabelFinance";
import DashboardContext from "../../../../Context";
import Formwallt from "../../../financialdepartment/workerWallet/Formwallt";

const Walletworker = () => {

    const { sideBardata, handelEdit, showformmicro, handeldmicro, loding } = useContext(DashboardContext)

    const [arryactions, setArryactions] = useState([]);

    const [sohwForm, setSohwForm] = useState(false);




    useEffect(() => {
        if (showformmicro) {

        }
        else {
            handelForm()
        }
        return () => {

        };
    }, [showformmicro]);

    useEffect(() => {
        if (sideBardata) {
            sideBardata.map(item => {
                item.controllers.filter(find => {
                    if (`/${find.controller}` === '/WorkerWallet') {
                        setArryactions(find.actions)
                        return find
                    }
                })
            })
        }
    }, []);

    const handelEditform = (id) => {
        setSohwForm(false)
        handeldmicro(false)
        handelEdit(id)
    }

    const additem = () => {
        setSohwForm(true)
    }

    const handelForm = () => setSohwForm(false)

    return (
        <>
            <Row>
                <Col md={12} sm={12} xs={12} >
                    {
                        sohwForm ?
                            <Button variant='danger' className='mb-3' onClick={() => handelEditform('')} >لغو</Button>
                            : arryactions.includes("Create") ?
                                <button type="button" className="btn btn-primary btn-icon-text btn-sm" onClick={additem} >
                                    افزودن {" "}
                                    <i className="fa fa-plus fa-lg"></i>
                                </button>
                                : null
                    }
                </Col>
            </Row>
            {
                sohwForm ?
                    <div style={{ padding: '20px', border: '2px solid #384db3', borderRadius: '10px', backgroundColor: '#ffff' }} >

                        <Formwallt handelForm={handelForm} urlWebsilte='/WorkerWallet' />
                    </div>
                    :
                    arryactions.includes('Get') ?
                        <TabelFinance urldata='/WorkerWallet' arryactions={arryactions} isnoid />
                        : "شما اجزا دسترسی به این بخش را ندارید :("
            }
        </>
    );
}

export default Walletworker